import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { RadioButton } from "primereact/radiobutton";
import React, { useState, useEffect } from "react";
import { createAPIEndpointServiceInvoice, EndpointServiceInvoice } from "../../Services/ServiceInvoice/ServiceInvoiceService";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import ServiceInvoice from "./ServiceInvoice";
import * as Fa from "react-icons/fa";
import Loader from "../../Components/Loader";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";


const ServiceInvoiceAllrecords = () => {
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const auth = storage.getLocal("user");
    const [endDate, setEndDate] = useState(new Date());
    const [strType, setStrType] = useState("S");
    const [allRecordsData, setGetAllRecords] = useState();
    const nav = useNavigate();
    const [showInvoice, setShowInvoice] = useState(false);
    const [surePopup, setSurePopup] = useState(false);
    const [RowDataCancel, setRowDataCancel] = useState();
    const [loading, setLoading] = useState(false);
    const [tag, setTag] = useState("");
    const [printData, setPrintData] = useState({});
    const [InvhId, setInvhId] = useState();


    const getAllRecords = async () => {
        setLoading(true);
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(startDate);
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        try {

            const response = await createAPIEndpointServiceInvoice().get(`${EndpointServiceInvoice.GetAllSerInv}?FromDate=${formattedStartDate}&ToDate=${formattedEndDate}&strtype=${strType}&CompId=${auth?.CompId}`);
            setGetAllRecords(response.data.Data);
            setLoading(false);
        } catch (err) {
            console.log("Error ", err);
            setLoading(false);
        }
    };

    useEffect(() => {
        setGetAllRecords([]);
    }, [strType]);


    // const handleViewEdit = () => {

    // };

    const ServiceInvoiceDetailsPage = () => {
        nav(`/salesmanagement/serviceinvoice/details?tag=${strType}`);
    };

    useEffect(() => {
        getAllRecords();
    }, []);

    const handlePrint = async (rowData, tag) => {
        setInvhId(rowData?.MASK_INVH_ID);
        if (tag == "S" || tag == "N") {
            setLoading(true);
            const payload = {
                invhId: rowData?.MASK_INVH_ID,
                eInvApplicability: auth?.EInvApplicability,
                ServiceType: strType
            };
            try {
                const response = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.PrintServiceInv}`, payload);
                console.log("response", response);
                setPrintData(response.data);
                setShowInvoice(true);
                setLoading(false);
                setTag(tag);
            } catch (err) {
                setLoading(false);
                console.log("Error ", err);
            }

        }

    };


    const handleDownload = async (rowData) => {
        setLoading(true);
        try {
            const response = await createAPIEndpointServiceInvoice().get(`${EndpointServiceInvoice.GetInvDetailsByUsrId}?strInv=${rowData?.MASK_INVH_ID}`);
            console.log("response", response);
            if (response.data.Data[0].PATH) {
                const url = response.data.Data[0].PATH;

                const a = document.createElement("a");
                a.href = url;
                a.setAttribute("download", `Service_Inv_${auth.CompId}.csv`);
                a.setAttribute("target", "_blank"); // Ensure it doesn't navigate current tab
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } // Trigger the download
            setLoading(false);
            // setTag(tag);
        } catch (err) {
            setLoading(false);
            console.log("Error ", err);
        }
    };
    const handleRetry = async (rowData) => {
        const Payload = {
            compId: auth.CompId,
            userId: auth.UserId,
            invhId: rowData?.MASK_INVH_ID,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvIRPUserPassword: auth?.EInvIRPUserPassword,
            eInvGSTNO: auth?.EInvGSTNO,
            SuppId: rowData?.SUPP_ID
        };
        try {
            const response = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.RetryEInv}`, Payload);
            console.log("response", response);
            toast.success(
                `${response.data.Message}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            getAllRecords();
        } catch (err) {
            setLoading(false);
            console.log("Error ", err);
            toast.error(
                `${err.response.data.Message}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
        }
    };

    const renderPrintButton = (rowData) => {
        if (strType === "R") {
            if ((rowData?.GST_NO !== null && rowData?.GST_NO !== "") && rowData.E_INV_FLAG === "N") {
                return null;

            }
            else if (rowData?.STATUS === "CN") {
                return null;
            }
            else {
                return (
                    <button
                        className="grid-icon"
                        title="Print"
                        onClick={() => handlePrint(rowData, "N")}
                    >
                        <Fa.FaPrint />
                    </button>
                );
            }
        }

        if (rowData.STATUS_MSG?.includes("Submitted")) return null;
        if (rowData.STATUS_MSG === "Cancelled") return null;
        if (rowData.STATUS === "OP" && (rowData.E_INV_FLAG === "N" || rowData.E_INV_FLAG === "")) return null;

        if ((rowData.E_INV_FLAG === "" || rowData.E_INV_FLAG === "Y" || rowData.E_INV_FLAG === "No") && rowData.STATUS === "OP") {
            return (
                <button
                    className="grid-icon"
                    title="Print"
                    onClick={() => handlePrint(rowData, "N")}
                >
                    <Fa.FaPrint />
                </button>
            );
        }

        if (rowData.STATUS === "OP" && (rowData.E_INV_FLAG === "N" || rowData.E_INV_FLAG === "")) {
            return (
                <button
                    className="grid-icon"
                    title="Print"
                    onClick={() => handlePrint(rowData, "N")}
                >
                    <Fa.FaPrint />
                </button>
            );
        }

        return null;
    };

    const onCancelInvoice = async () => {
        console.log("RowData",RowDataCancel);
        if (strType === "R") {
            setLoading(true);
            const Payload = {
                compId: auth.CompId,
                userId: auth.UserId,
                invhId: RowDataCancel?.MASK_INVH_ID,
                suppId: RowDataCancel?.SUPP_ID,
                eInvIRPUserId: auth.EInvIRPUserId,
                eInvIRPUserPassword: auth?.EInvIRPUserPassword,
                eInvGSTNO: auth?.EInvGSTNO,
                sI_Tag: strType
            };
            try {
                const response = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.CancelRSEServiceInvoice}`, Payload);
                toast.success(
                    `${response?.data?.Message}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                getAllRecords();
                setLoading(false);
            } catch (err) {
                toast.error(
                    `${err.response?.data?.Message}`,
                    {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 2000,
                    });
                setLoading(false);
                console.log("Error ", err);
            }
            finally{
                setSurePopup(false);
            }
            
        }
    };

    const renderCancelButton = (rowData) => {
        console.log("Console", rowData);

        const invhDateStr = rowData?.INVH_DATE;
        if (!invhDateStr) return null;

        // Expecting format: dd/MM/yyyy
        const parts = invhDateStr.split("/");
        if (parts.length !== 3) return null;

        const [day, month, year] = parts.map(Number);
        const invoiceDate = new Date(year, month - 1, day); // safer cross-browser
        const today = new Date();

        const diffInMs = today.getTime() - invoiceDate.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        // Skip if invoice is cancelled
        if (rowData?.STATUS === "CN") return null;

        // Skip if invoice is older than 30 days
        if (diffInDays > 30) return null;

        // GST-based conditions
        if (rowData?.GST_NO && rowData.GST_NO.trim() !== "") {
            if (rowData?.E_INV_FLAG === "N") return null;
            if (diffInDays > 1) return null;
        }

        return (
            <button className="grid-icon">
                <Fa.FaTimes
                    className="cancel"
                    onClick={() => {setSurePopup(true);setRowDataCancel(rowData);}}
                />
            </button>
        );
    };


    const renderSignButton = (rowData) => {
        // Hide the Sign button if STATUS_MSG is "Save as Draft" or if it's "Cancelled"
        if (rowData.STATUS_MSG === "Save as Draft" || rowData.STATUS_MSG === "Cancelled") {
            return null;
        }

        if (rowData.E_INV_FLAG !== "Y" && rowData.E_INV_FLAG !== "Yes") {
            return null;
        }
        // When "Approved by CSM" and conditions are met for signing
        if (
            rowData.STATUS_MSG === "Approved by CSM" &&
            (rowData.IS_SIGNED === "" || rowData.IS_SIGNED === "N" || rowData.IS_SIGNED === "No") &&
            rowData.FINAL_STATUS === "Y" &&
            rowData.STATUS === "G"
        ) {
            return (
                <button
                    className="grid-icon"
                    title="Click Here To Sign PDF"
                    onClick={() => handlePrint(rowData, "S")}
                >
                    <Fa.FaSignature />
                </button>
            );
        }

        //Additional conditions for hiding the Sign button if E_INV_FLAG is "Y" or "Yes" with "OP" status
        if (
            (rowData.E_INV_FLAG === "Y" || rowData.E_INV_FLAG === "Yes") &&
            rowData.STATUS === "OP" &&
            rowData.FINAL_STATUS === "Y"
        ) {
            return null; // Hide the Sign button
        }

        return null; // No Sign button by default
    };

    const renderDownloadButton = (rowData) => {
        // Hide the Download button if STATUS_MSG is "Submitted" or "Cancelled"
        if (rowData.STATUS_MSG?.includes("Submitted") || rowData.STATUS_MSG === "Cancelled") {
            return null;
        }

        // Hide the Download button if STATUS is "OP" and E_INV_FLAG is a non-breaking space (equivalent to td 18 == "\xa0")
        if (rowData.STATUS === "OP" && rowData.E_INV_FLAG === "") {
            return null;
        }

        // Show when E_INV_FLAG is "", "Y", or "Yes" and FINAL_STATUS is "Y"
        if (
            (rowData.IS_SIGNED === "" || rowData.IS_SIGNED === "Y" || rowData.IS_SIGNED === "Yes") &&
            rowData.STATUS === "OP" &&
            rowData.FINAL_STATUS === "Y"
        ) {
            return (
                <button
                    className="grid-icon"
                    title="Download PDF"
                    onClick={() => handleDownload(rowData)}
                >
                    <Fa.FaDownload />
                </button>
            );
        }

        // Also allow when STATUS is OP and E_INV_FLAG is "" or "N"
        if (
            rowData.STATUS === "OP" &&
            (rowData.E_INV_FLAG === "" || rowData.E_INV_FLAG === "N")
        ) {
            return (
                <button
                    className="grid-icon"
                    title="Download PDF"
                    onClick={() => handleDownload(rowData)}
                >
                    <Fa.FaDownload />
                </button>
            );
        }

        return null;
    };


    const renderRetryButton = (rowData) => {
        // Check if invoice is older than 30 days
        const invhDateStr = rowData?.INVH_DATE;
        if (invhDateStr) {
            const parts = invhDateStr.split("/");
            if (parts.length === 3) {
                const [day, month, year] = parts.map(Number);
                const invoiceDate = new Date(year, month - 1, day);
                const today = new Date();
                const diffInMs = today.getTime() - invoiceDate.getTime();
                const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
                
                // Don't show Retry button if invoice is older than 30 days
                if (diffInDays > 30) return null;
            }
        }

        // 🔹 R-specific override
        if (strType === "R") {
            if ((rowData?.GST_NO !== null && rowData?.GST_NO !== "") && rowData.E_INV_FLAG === "N") {
                // Show Retry button
                return (
                    <button
                        className="grid-icon"
                        title="Retry"
                        onClick={() => handleRetry(rowData)}
                    >
                        <Fa.FaRedo />
                    </button>
                );
            } else {
                // Don't show Retry for other "R" cases
                return null;
            }
        }

        // 🔹 Fallback to your existing Retry logic (unchanged)
        if (rowData?.E_INV_FLAG === "N") {
            return (
                <button
                    className="grid-icon"
                    title="Retry E-Invoice"
                    onClick={() => handleRetry(rowData)}
                >
                    <Fa.FaRedo />
                </button>
            );
        }

        return null;
    };




    const renderViewButton = (rowData) => (
        <button
            className="grid-icon"
            title="View"
            onClick={() => nav(`/salesmanagement/serviceinvoice/details?tag=${strType}&id=${rowData?.MASK_INVH_ID}&startDate=${startDate}&endDate=${endDate}`)}
        >
            <Fa.FaEye />
        </button>
    );

    const handleSave = async (rowData) => {
        const payload = {
            compId: auth.CompId,
            userId: auth.UserId,
            invhId: rowData?.MASK_INVH_ID,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvIRPUserPassword: auth?.EInvIRPUserPassword,
            eInvGSTNO: auth?.EInvGSTNO,
            SuppId: rowData?.SUPP_ID
        };

        try {
            const response = await createAPIEndpointServiceInvoice().post(`${EndpointServiceInvoice.SaveSInvStatus}`, payload);
            console.log("response", response);
            toast.success(
                `${response.data.Message}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
            getAllRecords();
        } catch (err) {
            setLoading(false);
            console.log("Error ", err);
            toast.error(
                `${err.response.data.Message}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
        }
    };

    const renderSaveButton = (rowData) => {
        // Show Save button when STATUS_MSG is "Pending"
        if (rowData.STATUS_MSG === "Approved by CSM" && (rowData.IS_SIGNED === "" || rowData.IS_SIGNED === "N" || rowData.IS_SIGNED === "No") && (rowData.FINAL_STATUS === "N") && (rowData.STATUS === "G")) {
            return (
                <button
                    className="grid-icon"
                    title="Save Service Invoices"
                    onClick={() => handleSave(rowData)}
                >
                    Save
                </button>
            );
        }

        return null;
    };

    const handleRadioButton = async (e) => {
        setStrType(e.value);
        setLoading(true);
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(startDate);
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        try {

            const response = await createAPIEndpointServiceInvoice().get(`${EndpointServiceInvoice.GetAllSerInv}?FromDate=${formattedStartDate}&ToDate=${formattedEndDate}&strtype=${e.value}&CompId=${auth?.CompId}`);
            setGetAllRecords(response.data.Data);
            setLoading(false);
        } catch (err) {
            console.log("Error ", err);
            setLoading(false);
        }
    };

    const isSelectable = (data) => strType === "R" && data?.STATUS == "CN";
    const rowClassName = (data) => (isSelectable(data) ? "p-disabled" : "");


    if (loading) {
        return (
            <Loader />
        );
    }
    else {
        return (
            <>

                <div className="col-12 pt-0 pb-4">
                    <div className='row d-flex justify-content-center align-items-center mb-2'>
                        <div className="col-lg-3 col-md-12 col-sm-12">
                            <h3 className='mb-0'>Service Invoice</h3>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <form>
                                <div className="d-flex justify-content-center">
                                    <div className="d-inline-flex">
                                        <RadioButton
                                            name="Type"
                                            value="N"
                                            onChange={(e) => {
                                                handleRadioButton(e);
                                                // GetAllRecordsofCustomerForReactivation(e.value);
                                                // setActiveIndex(0);
                                            }}
                                            checked={strType === "N"}
                                        />
                                        <label className="mx-2">Normal Service Invoice</label>
                                        <RadioButton
                                            name="Type"
                                            value="S"
                                            onChange={(e) => {
                                                handleRadioButton(e);
                                                // GetAllRecordsofCustomerForReactivation(e.value);
                                                // setActiveIndex(0);
                                            }}
                                            checked={strType === "S"}
                                        />
                                        <label className="mx-2">SSR Service Invoice</label>
                                        <RadioButton
                                            name="Type"
                                            value="R"
                                            onChange={(e) => {
                                                handleRadioButton(e);
                                                // GetAllRecordsofCustomerForReactivation(e.value);
                                                // setActiveIndex(0);
                                            }}
                                            checked={strType === "R"}
                                        />
                                        <label className="mx-2">RSE Service Invoice</label>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className='text-end'>
                                <button type="button" className="btn btn-primary" onClick={ServiceInvoiceDetailsPage}>Add New</button>
                            </div>
                        </div>
                    </div>
                    <section className="sales-box">
                        <form>
                            <div className="row d-flex justify-content-end align-items-end">
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <label className="form-label">From Date</label>
                                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} dateFormat="dd/mm/yy" showIcon />
                                </div>
                                <div className="col-lg-4 col-md-6 col-sm-12">
                                    <label className="form-label">To Date</label>
                                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} dateFormat="dd/mm/yy" showIcon />
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <div className="text-end">
                                        <button type="button" className="btn btn-primary" onClick={getAllRecords}>Get {strType == "S" ? "Service Invoices" : strType == "N" ? "Normal Invoices" : "RSE Invoices"}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                    <section className="mt-3">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <h3>Records</h3>
                                <div className="DataTable pt-1 pb-4">
                                    <DataTable value={allRecordsData}
                                        paginator
                                        rows={10}
                                        responsiveLayout="scroll"
                                        dataKey="MASK_INVH_ID"
                                        rowClassName={rowClassName}
                                        rowSelectable={(rowData) => strType === "R" && rowData.STATUS !== "OP"}
                                    >
                                        {strType !== "R" && <Column field="REF_INVH_NO" header="Reference Invoice No." />}
                                        <Column field="INVH_NO" header="Invoice No." />
                                        <Column field="INVH_DATE" header="Invoice Date" />

                                        {/* Hidden columns in ASPX: You can omit or keep hidden via styles */}
                                        {/* <Column field="E_INV_FLAG" header="E_INV_FLAG" style={{ display: 'none' }} /> */}
                                        {/* <Column field="STATUS" header="STATUS" style={{ display: 'none' }} /> */}
                                        {/* <Column field="FINAL_STATUS" header="Final Status" style={{ display: 'none' }} /> */}
                                        {/* <Column field="IRN_NO" header="IRN No" style={{ display: 'none' }} /> */}

                                        {strType === "R" ? <Column field="SUPP_NAME" header="RSE Name" /> : <Column field="SUPP_NAME" header="Supplier Name" />}
                                        {/* MASK_INVH_ID is the dataKey, used for selection or expansion logic */}

                                        <Column field="STATUS_MSG" header="Status" />
                                        <Column body={(rowdata) => rowdata.IS_SIGNED == "Y" ? "Yes" : "No"} header="Digitally Signed" />

                                        {/* Action Buttons */}
                                        {(strType === "N" || strType === "R") && <Column header="Print" body={renderPrintButton} />}
                                        <Column header="View" body={renderViewButton} bodyClassName="allow-interaction" />
                                        {strType === "S" && <Column header="Download" body={renderDownloadButton} />}
                                        <Column header="Retry" body={renderRetryButton} />
                                        <Column header="Sign" body={renderSignButton} />
                                        {strType !== "R" && <Column header="Save" body={renderSaveButton} />}
                                        {strType === "R" && <Column header="Cancel" body={renderCancelButton} />}
                                        {/* Cancel column was hidden in ASPX */}
                                    </DataTable>

                                </div>
                            </div>
                        </div>
                        {/* <button onClick={() => setShowInvoice(true)}> show Invoice </button> */}
                    </section>
                </div>
                <Dialog
                    header="Information"
                    visible={surePopup}
                    style={{ width: "50vw" }}
                    // onHide={() => setSurePopup(false)}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div>
                        <p className="mb-0">
                            Are you sure to Delete the RSE Invoice ?
                        </p>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="float-end">
                            <button
                                type="button"
                                className="btn btn-primary me-3"
                                onClick={()=>onCancelInvoice()}
                            >
                                OK
                            </button>
                            <button
                                type="button"
                                className="btn btn-cancel-red"
                                onClick={() => {
                                    setSurePopup(false);
                                }}
                            >
                                Cancel 
                            </button>
                        </div>
                    </div>
                </Dialog>
                <ServiceInvoice DCpopup={showInvoice} setDCPopup={setShowInvoice} printData={printData} tag={tag} invhid={InvhId} getAllRecords={getAllRecords} strType={strType} />
            </>
        );
    }
};

export default ServiceInvoiceAllrecords;